(function () {
  'use strict';

  if (window.__hushReservationCartCompat) return;
  window.__hushReservationCartCompat = true;

  var cartSelector = 'cart-items, cart-drawer-items';
  var quantitySelector = 'input[name="updates[]"][data-index]';

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function elementTarget(event) {
    return event.target && event.target.nodeType === 1 ? event.target : null;
  }

  function consume(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function context(control, input) {
    var cart = control.closest(cartSelector);
    var index = control.getAttribute('data-index') || (input && input.getAttribute('data-index'));
    var line = Number(index);
    if (!cart || !Number.isSafeInteger(line) || line < 1) return null;
    return { cart: cart, line: line, input: input };
  }

  function busy() {
    // Native CartItems marks this synchronously, including when both cart surfaces exist.
    return Boolean(document.querySelector('#main-cart-items.cart__items--disabled, #CartDrawer-CartItems.cart__items--disabled'));
  }

  function showUnavailable(cart) {
    var error = cart.querySelector('#cart-errors, #CartDrawer-CartErrors');
    if (error) error.textContent = 'Please refresh the page and try updating your cart again.';
  }

  function syncCartSections(cart) {
    if (!onCartPage() || cart.__hushReservationSections || typeof cart.getSectionsToRender !== 'function') return;
    var original = cart.getSectionsToRender;
    cart.getSectionsToRender = function () {
      var sections = original.call(this).slice();
      var targets = [
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'main-cart-items', selector: '.js-contents' },
        { id: 'main-cart-footer', selector: '.js-contents' },
        { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' }
      ];
      targets.forEach(function (target) {
        var element = document.getElementById(target.id);
        var section = target.section || (element && element.getAttribute('data-id'));
        if (!element || !section || sections.length >= 5 || sections.some(function (existing) { return existing.id === target.id; })) return;
        sections.push({ id: target.id, section: section, selector: target.selector });
      });
      return sections;
    };
    cart.__hushReservationSections = true;
  }

  function update(ctx, quantity) {
    if (typeof ctx.cart.updateQuantity !== 'function') {
      showUnavailable(ctx.cart);
      return;
    }
    // The theme submits the existing line number to cart/change.js. Its selling plan
    // and properties stay on that line. Patrol still wraps the request for inventory.
    // Refresh both visible cart surfaces using the same response, within Shopify's
    // five-section limit, so the unopened drawer cannot retain an outdated line index.
    syncCartSections(ctx.cart);
    ctx.cart.updateQuantity(ctx.line, quantity, ctx.input ? ctx.input.name : undefined);
  }

  function handleClick(event) {
    var target = elementTarget(event);
    if (!target) return;

    var remove = target.closest('cart-remove-button[data-index]');
    if (remove) {
      var row = remove.closest('.cart-item');
      var removeContext = context(remove, row && row.querySelector(quantitySelector));
      if (!removeContext) return;
      consume(event);
      if (!busy()) update(removeContext, 0);
      return;
    }

    // Patrol's identity-losing quantity handlers are confined to the full-cart route.
    // Elsewhere the theme already updates drawer lines correctly.
    if (!onCartPage()) return;
    var button = target.closest('quantity-input button[name="plus"], quantity-input button[name="minus"]');
    if (!button) return;
    var quantityInput = button.closest('quantity-input').querySelector(quantitySelector);
    var ctx = context(button, quantityInput);
    if (!ctx || !quantityInput) return;
    consume(event);
    if (busy() || button.disabled || quantityInput.disabled) return;

    var previousValue = quantityInput.value;
    try {
      if (button.name === 'plus') quantityInput.stepUp();
      else quantityInput.stepDown();
    } catch (_) {
      quantityInput.reportValidity();
      return;
    }
    var quantity = Number(quantityInput.value);
    if (!Number.isSafeInteger(quantity) || quantity < 0 || !quantityInput.checkValidity()) {
      quantityInput.value = previousValue;
      quantityInput.reportValidity();
      return;
    }
    if (quantityInput.value === previousValue) return;
    update(ctx, quantity);
  }

  function handleChange(event) {
    if (!onCartPage()) return;
    var input = elementTarget(event);
    if (!input || !input.matches(quantitySelector)) return;
    var ctx = context(input, input);
    if (!ctx) return;
    consume(event);
    if (busy() || input.disabled) return;
    var quantity = Number(input.value);
    if (input.value.trim() === '' || !Number.isSafeInteger(quantity) || quantity < 0 || !input.checkValidity()) {
      input.reportValidity();
      return;
    }
    update(ctx, quantity);
  }

  // Window capture runs before the app's document capture handlers, independent
  // of script registration order. Delegation survives Shopify section replacement.
  window.addEventListener('click', handleClick, true);
  window.addEventListener('change', handleChange, true);
})();
